import { pendingAuthContext } from "@crm/access/auth/state";
import type { RouterContext } from "@crm/access/types/router";
import { createRouter } from "@tanstack/react-router";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";

/**
 * Router 工厂函数
 *
 * 创建新的 Router 实例，每个请求都创建独立的 context
 * 确保 SSR 时不会跨请求共享状态
 *
 * 认证状态将在 __root.tsx 中通过 Better Auth 的 useSession hook 获取
 * 并通过 RouterProvider 的 context prop 传递给 Router
 */
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {
      // auth 将由 RootComponent 动态注入
      auth: pendingAuthContext(),
    } satisfies RouterContext,
    scrollRestoration: true,
    // 🚀 全局启用 intent preloading: hover 时预加载路由
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
  });

  return router;
};
